import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { Blueprint } from "types/generated";
import { AccessResult, hasAdminAccess, NO_ACCESS_MESSAGE } from "utils/access";

const useCanManageBlueprint = (): ((blueprint?: Blueprint) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (blueprint?: Blueprint) => {
      if (!blueprint) {
        return { result: false };
      }

      if (blueprint.deleted) {
        return { result: false };
      }

      if (viewer.admin) {
        return { result: true };
      }

      const result = hasAdminAccess(viewer, blueprint.space.id);

      if (result) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanManageBlueprint;
